module.exports = __webpack_public_path__ + "static/media/MSMEBen2.eb03af43.svg";